
/**
 *
 * @enum EventType
 *
 * the kinds of events the KRPano emits
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */

export enum EventType {
  ENTER_FULLSCREEN='ENTER_FULLSCREEN',
  EXIT_FULLSCREEN='EXIT_FULLSCREEN',
  XML_COMPLETE='XML_COMPLETE',
  LOAD_COMPLETE='LOAD_COMPLETE',
  BLEND_COMPLETE='BLEND_COMPLETE',
  NEW_PANO='NEW_PANO',
  REMOVE_PANO='REMOVE_PANO',
  NEW_SCENE='NEW_SCENE',
  XML_ERROR='XML_ERROR',
  LOAD_ERROR='LOAD_ERROR',
  KEY_DOWN='KEY_DOWN',
  KEY_UP='KEY_UP',
  CLICK='CLICK',
  SINGLE_CLICK='SINGLE_CLICK',
  DOUBLE_CLICK='DOUBLE_CLICK',
  MOUSE_DOWN='MOUSE_DOWN',
  MOUSE_UP='MOUSE_UP',
  MOUSE_WHEEL='MOUSE_WHEEL',
  CONTEXT_MENU='CONTEXT_MENU',
  IDLE='IDLE',
  VIEW_CHANGE='VIEW_CHANGE',
  VIEW_CHANGED='VIEW_CHANGED',
  RESIZE='RESIZE',
  FRAMEBUFFER_RESIZE='FRAMEBUFFER_RESIZE',
  AUTO_ROTATE_START='AUTO_ROTATE_START',
  AUTO_ROTATE_STOP='AUTO_ROTATE_STOP',
  AUTO_ROTATE_ONEROUND='AUTO_ROTATE_ONEROUND',
  AUTO_ROTATE_CHANGE='AUTO_ROTATE_CHANGE',
  IPHONE_FULLSCREEN='IPHONE_FULLSCREEN',
  NONE='NONE'
}
